function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMccServices = function SvgMccServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 5a1 1 0 0 0-1-1H15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v3.082C10.051 12.736 2.63 17.276 2.038 25 1.996 25.55 2.448 26 3 26h34c.552 0 1.004-.45.962-1C37.371 17.275 29.95 12.735 22 12.081V9a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1V5ZM2.694 30a2 2 0 0 0-1.973 1.671l-.333 2A2 2 0 0 0 2.361 36h35.278a2 2 0 0 0 1.973-2.329l-.334-2A2 2 0 0 0 37.306 30H2.694Z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccServices;